var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextEditStyle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0872 6.70394C14.9271 5.86083 16.2664 5.8182 17.1568 6.57786L17.2869 6.69783L17.4134 6.83443C18.1376 7.68297 18.1376 8.93756 17.4134 9.78611L17.293 9.9166L10.4167 16.8192C10.2617 16.9748 10.0749 17.094 9.86988 17.1691L9.71291 17.217L6.62737 17.9772C6.28827 18.0608 5.98023 17.7822 6.00917 17.4507L6.0236 17.3669L6.81558 14.2961C6.86895 14.0892 6.96574 13.8967 7.09885 13.7311L7.20537 13.6121L14.0872 6.70394ZM16.5811 7.40628C16.1201 6.94698 15.393 6.91769 14.898 7.31746L14.7957 7.40969L7.91383 14.3178C7.87193 14.3599 7.83804 14.4089 7.8135 14.4624L7.7839 14.5459L7.20061 16.8059L9.47368 16.246C9.51317 16.2363 9.55114 16.2218 9.58682 16.2031L9.6385 16.1717L9.70829 16.1134L16.5845 9.21084C17.0806 8.71291 17.0806 7.90762 16.5811 7.40628ZM6.42419 2.22965L6.46607 2.31408L9.448 9.94309L8.676 10.7181L8.004 8.99909H4.007L2.96614 11.6788C2.87719 11.9076 2.63835 12.0338 2.40561 11.9887L2.31893 11.9636C2.09015 11.8747 1.96399 11.6358 2.00906 11.4031L2.03413 11.3164L5.53436 2.31489C5.6877 1.92056 6.21661 1.89194 6.42419 2.22965ZM6.00061 3.87186L4.396 7.99909H7.614L6.00061 3.87186Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextEditStyle);
export default __webpack_public_path__ + "static/media/TextEditStyle.a35d6b06839f36632da41dda04f803f2.svg";
export { ForwardRef as ReactComponent };